// extracted by mini-css-extract-plugin
export default {"SwipeLeftToClose":"bei_a bhf_bk bhf_bl bhf_bo","SwipeLeftToClose--animating":"bei_b"};